export const environment = {
  production: false,
  applicationCode: 'VTSPORTS_QLCT',
  keycloak: {
    url: "http://10.60.98.97:8082",
    realm: "VTIT_DEV",
    clientId: "hr-tool-frontend",
  },
  vtSso: {
    // loginDomain: "https://sso2.viettel.vn:8003",
    // loginDomain: "https://10.30.132.79:8225",
    loginDomain: "https://sso-public.viettel.vn",
    serviceValidate: "https://171.244.14.154", // current
  },
  apiUrl: "https://qlct.thecongviettelfc.vn", // qlct
  contextPath: '/api/v1/profiles',
  contextPathAdmin: '/api/v1/admin',
  contextPathNotify: '/api/v1/notify',
  contextPathOperate: '/api/v1/operate',
  contextPathTarget: '/api/v1/target',
  contextPathDashboard: '/api/v1/dashboard',
  config: {
    isHorizontalMenu: false,
  }
};
